import React from 'react'
import Navbar from '../inc/Navbar'
import Slider from '../inc/Slider'
import about from "../images/About.jpeg";
import "./Home.css"
import SlideButton from './SlideButton';
import GoogleMap from './GoogleMap';
import About from './About';
import PrintApplication from './PrintApplication';
import ScrollToTop from "react-scroll-to-top"

function Home() {
  return (
    <div>
      <Navbar/>
      <br/>
      <br/>
   
       
             <div className="album py-2">
                <div className="container">
                    <h6>MAA MANASHA COLLEGE OF PHARMACY</h6>
                </div>
            </div>
      <Slider/>
      <br/>
      <ScrollToTop smooth top="100" color="Gray" />
      <SlideButton/>
      <About/>
           <div className='applynew'>
       
       <div className="album py-0">
        <div className="container">
            <div className="row">
            <div className="col-md-7">
          <hr  style={{color:"#fff1f2"}}/>
        
      
            </div>
         
          </div>
          </div>
          
        </div>

      <PrintApplication/>
  
      </div>
    
                              <GoogleMap/>
                              
                            
    </div>
  )
}

export default Home